export default {
  menu: {
    sports: "کھیل",
    referAndEarn: "حوالہ دیں اور کمائیں",
    referDesc: "60% تک کمیشن",
    copyLink: "لنک کاپی کریں",
    hot: "مقبول",
    favorites: "پسندیدہ",
    recent: "حالیہ",
    vipClub: "VIP کلب",
    bonus: "بونس",
    bonusGames: "بونس گیمز",
    affiliate: "ملحق",
    promotion: "پروموشن",
    rewards: "انعامات",
    help: "مدد",
    feedback: "رائے",
    downloadApp: "ایپ ڈاؤن لوڈ کریں",
    claimBonus: "بونس حاصل کریں",
    redeemCode: 'کوڈ ریڈیم کریں',
    redeemDesc: 'مفت انعام حاصل کریں',
    liveSupport: "لائیو سپورٹ",
    language: "زبان",
	search: "search"
  }
}
